import {Component, OnInit, Input, OnDestroy, AfterContentInit} from '@angular/core';
import {Subscription} from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { OpenBarDialogComponent } from '../../dialogs/openBar-dialog/openBar.dialog.component';
import { FormControl } from '@angular/forms';
import { EditVisitDialogComponent } from '../../dialogs/edit-visit/edit.component';
import { LaneState } from '../../classes/lane.class';
import { AppConfigService } from '../../../../services/app-config.service';
import { LaneStateService } from '../../../../services/lane-state.service';
import { WebSocketService } from '../../../../services/web-socket.service';
import { AuthenticationService } from '../../../../services/authentication.service';
import { NotificationService } from '../../../../services/notification.service';
import { State } from '../../classes/state.class';



// tslint:disable-next-line:class-name
interface movement {
  time: string;
  plate: string;
}

// tslint:disable-next-line:class-name
interface person {
  time: string;
  card: string;
}


@Component({
  selector: 'app-barcontrol-viewer',
  templateUrl: './bar-control-viewer.component.html',
  styleUrls: ['./bar-control-viewer.component.css']
})
export class BarControlViewerComponent implements OnInit, AfterContentInit {

  public lane: LaneState;
  private laneSubscription: Subscription;
  private lastMovementsSubscription: Subscription;
  private lastPersonsSubscription: Subscription;
  private openBarReassonSubscription: Subscription;
  public platePath: string;
  public ocrResultPacket;
  public currentState;
  public plate: string;
  public name: string;
  public result: string;
  public imagePath: string;
  public liveview: string;
  public liveviewSwitch: boolean;
  public lastMovements: movement[] = [];
  public lastPersons: person[] = [];
  public currentPlate: string;
  public laneState0: LaneState;
  public frontPlateForm: FormControl;
  public showCreateVisit: boolean;
  public createVisitTimeout: any;
  public gasoilDispenserVolume: number;
  public gasoilDispenserAmount:number;
  public adBlueDispenserVolume: number;
  public adBlueDispenserAmount:number;
  public movementFrontImageSrc: any;

  @Input() laneId: number;
  @Input() laneType: string;
  @Input() laneConfig;

  constructor(
    private appConfig: AppConfigService,
    private laneData: LaneStateService,
    private wsService: WebSocketService,
    private authService: AuthenticationService,
    private dialog: MatDialog,
    private notificationService: NotificationService
  ) {
    this.showCreateVisit = false;
    this.lane = null;
    this.currentPlate = null;
    this.currentState = null;
    this.lastMovements = [];
    this.lastPersons = [];
    this.frontPlateForm = new FormControl('');
  }

  ngOnInit() {

    this.laneSubscription = this.laneData.getStateLane(this.laneId)
      .subscribe((laneState: LaneState) => {
        this.processLaneState(laneState);
    });
    this.lastMovementsSubscription = this.laneData.getLastMovements(this.laneId).subscribe((movements: any) => {
      this.lastMovements = movements;
    });
    this.lastPersonsSubscription = this.laneData.getLastPersons(this.laneId).subscribe((persons: any) => {
      this.lastPersons = persons;
    });

    this.initVars();
    this.getLiveview();


  }

  ngAfterContentInit(){
      /*
      this.laneData.setStateZero(this.laneId).subscribe((laneState: LaneState) => {
        this.processLaneState(laneState);
      });
      */
      this.laneData.getCurrentLaneData(this.laneId);
      console.log ('laneData setStateZero ' + (this.laneId));

  }

  OnDestroy() {
    this.laneSubscription.unsubscribe();
    this.lastMovementsSubscription.unsubscribe();
    this.lastPersonsSubscription.unsubscribe();
  }

  initVars(){
    this.currentState = 'IDDLE';
    if (this.laneConfig.general.statesMachine === 'StatMachMoventiaWash') {
      this.imagePath = `${this.appConfig.getConfig().installationNameFolder}access-manager/assets/washer-images/waiting.jpg`;
    }
    else if(this.laneConfig.general.statesMachine === 'StatMachMoventiaDispenser') {
      this.imagePath = `${this.appConfig.getConfig().installationNameFolder}access-manager/assets/dispenser-images/waiting.png`;
    }
    else {
      this.imagePath = `${this.appConfig.getConfig().installationNameFolder}access-manager/assets/lane-images/C.jpg`;
    }
  }

  processLaneState(laneState) {

        this.lane = laneState;
        console.log('laneId: ' + this. laneId + ', laneType ' + this.laneConfig.general.laneType);
        console.log( 'L-' + this.laneId + ' lane state actualizado currentState: ' + JSON.stringify(this.lane));
        if (this.lane == null) {
          return;
        }
        if (this.lane != null) {
          this.currentState = this.lane.stateMach.currentState;
          if (this.laneConfig.general.laneType === 'vehicles'){
              this.getImagePath(this.lane.state, this.lane.dispensers);
              this.getPlatePath(this.lane.OCRPacket?.path_plate);
              this.getOCRResultPacket(this.lane.OCRPacket, this.lane.presenceTimeStamp);
          }
          if (this.lane.stateMach.currentState === 'IDDLE') {
              this.resetStaticInfo();
          }else {
              this.setStaticInfo(this.lane);
              // tslint:disable-next-line:max-line-length
              if (this.lane.stateMach.currentState === 'deniedState'){
                  this.showCreateVisit = true;
              }
              if (this.lane.stateMach.currentState === 'idleState'){
                  this.showCreateVisit = false;
              }
          }
        } else {
          if (this.laneConfig.general.laneType === 'vehicles'){
              this.getImagePath(this.lane[this.laneId].state, this.lane[this.laneId].dispensers);
              this.getPlatePath(this.lane[this.laneId].OCRPacket.front.path_plate);
              this.getOCRResultPacket(this.lane[this.laneId].OCRFrontResultPacket, this.lane.presenceTimeStamp);
          }
        }

      }

  resetStaticInfo(){
    this.showCreateVisit = false;
    this.plate = '';
    this.name = '';
    this.result = '';
    this.frontPlateForm.setValue(null);
  }
  // tslint:disable-next-line:variable-name
  setStaticInfo(lane_data){
    if (lane_data.OCRFrontResultPacket && lane_data.OCRFrontResultPacket.plate && lane_data.OCRFrontResultPacket?.plate !== '') {
      this.frontPlateForm.setValue(lane_data.OCRFrontResultPacket.plate);
      this.plate = lane_data.OCRFrontResultPacket.plate;
    }
    // tslint:disable-next-line:max-line-length
    if (lane_data.authResponsePacket.authorization && lane_data.authResponsePacket.authorization.name && lane_data.authResponsePacket.authorization.name !== '') {
      this.name = lane_data.authResponsePacket.authorization.name;
    }
    // tslint:disable-next-line:max-line-length
    /*if (lane_data.authResponsePacket.authorization && lane_data.authResponsePacket.authorization.strResult && lane_data.authResponsePacket.authorization.strResult !== '') {
      this.result = lane_data.authResponsePacket.authorization.strResult;
    }*/
    if (lane_data.authResponsePacket.authorization){
      if(this.laneConfig.general.statesMachine === 'StatMachMoventiaWash') {
        this.result = lane_data.authResponsePacket.authorization.strResultWash;
      } else if (this.laneConfig.general.statesMachine === 'StatMachMoventiaDispenser') {
        this.result = lane_data.authResponsePacket.authorization.strResultFuel;
      } else {
        this.result = lane_data.authResponsePacket.authorization.strResult;
      }
    }
  }

  getLiveview() {

    this.liveview = this.laneId.toString();
  }

  // tslint:disable-next-line:no-shadowed-variable
  getImagePath = (state: State, dispensers?: any) => {
    this.imagePath = `${this.appConfig.getConfig().installationNameFolder}access-manager/assets/`;
    if (this.laneConfig.general.statesMachine === 'StatMachMoventiaWash') {
      this.imagePath = this.imagePath.concat('washer-images/') ;
      if (state.presence.state != null && state.presence.state === true) {
      this.imagePath = this.imagePath.concat('L1_');
      }
      if (state.washing_signal.state != null && state.washing_signal.state === true) {
        this.imagePath = this.imagePath.concat('washing.jpg');
      } else {
        this.imagePath = this.imagePath.concat('waiting.jpg');
      }
    }
    else if (this.laneConfig.general.statesMachine === 'StatMachMoventiaDispenser') {
      this.imagePath = this.imagePath.concat('dispenser-images/');
      if (state.presence.state != null && state.presence.state === true) {
        this.imagePath = this.imagePath.concat('L1_');
        }
        else {
          this.imagePath = this.imagePath.concat('waiting_'); 
        }
        if (dispensers && dispensers[0]?.name === 'gasoil') {
          this.imagePath = this.imagePath.concat('GASOIL_');
          if ( dispensers && dispensers[0]?.nozzle_status.state === true) {
            this.imagePath = this.imagePath.concat('d_');
          } else {this.imagePath = this.imagePath.concat('c_')};
          if (dispensers && dispensers[0]?.filling_signal?.state === true){
            this.imagePath = this.imagePath.concat('f');
          }else {
            this.imagePath = this.imagePath.concat('u');
          }
          }
        if (dispensers && dispensers[1]?.name === 'adBlue') {
          this.imagePath = this.imagePath.concat('ADBLUE_');
          if (dispensers && dispensers[1]?.nozzle_status.state === true) {
            this.imagePath = this.imagePath.concat('d_');
          } else {this.imagePath = this.imagePath.concat('c_')};
          if (dispensers && dispensers[1]?.filling_signal.state === true){
            this.imagePath = this.imagePath.concat('f');
          }else  {
            this.imagePath = this.imagePath.concat('u');
          }
          }
        this.imagePath = this.imagePath.concat('.png');

    }
    else {
      this.imagePath = this.imagePath.concat('lane-images/');
      if (state.presence && state.presence.state != null && state.presence.state === true) {
      this.imagePath = this.imagePath.concat('L1_');
      }
      if (state.security && state.security.state != null && state.security.state === true) {
        this.imagePath = this.imagePath.concat('L2_');
      }
      if (state.photocell && state.photocell.state != null && state.photocell.state === true) {
        this.imagePath = this.imagePath.concat('FC_');
      }
      if (state.blocked && state.blocked.state != null && state.blocked.state === true) {
        this.imagePath = this.imagePath.concat('B_');
      }
      if (state.closed && state.closed.state != null && state.closed.state === true) {
        this.imagePath = this.imagePath.concat('C.jpg');
      } else {
        this.imagePath = this.imagePath.concat('O.jpg');
      }
    }
  }
  getPlatePath = (path: string) => {
    if (path == null) {
      return;
    }
    if (path.length < 4) {
      return;
    } else {
      this.platePath = path;
    }
  }
  getOCRResultPacket = (packet: any, timeStamp: string) => {
    if (packet.front ==null || packet.front.path_plate == null) {
      return;
    }else {
      this.ocrResultPacket = packet;
      const spaceId = timeStamp.indexOf(' ', 9);
      // console.log('spaceId: ' + spaceId);
      let presenceDate = '';
      presenceDate = timeStamp.substring(0, spaceId);
      presenceDate = presenceDate.replace('-', '');
      presenceDate = presenceDate.replace('-', '');
      this.ocrResultPacket.presenceTimeStamp = presenceDate;
      // console.log(this.ocrResultPacket.presenceTimeStamp);
    }
  }
  /*
  openBar(id): void {
    console.log('abrir la barrera', id);
    const payload = {
      msg_type: 'open',
      lane: id,
      openingUser: this.authService.currentUser.name,
      openingMsg: 'blablabla'
    };
    this.ws.emit('bar', payload);
  }*/
  /*
  openBar(id: number) {
    console.log('abrir la barrera', id);
    const payload = {
      msg_type: 'open',
      lane: id,
      openingUser: this.authService.currentUser.name,
      openingMsg: ''
    };
    const dialogRef = this.dialog.open(OpenBarDialogComponent, {
      width: '400px',
      disableClose: true,
      data: payload
    });
    this.openBarReassonSubscription = dialogRef.afterClosed().subscribe(
      value => {
        if (value) {
          console.log(value);
          this.wsService.send('bar', value);
          this.notificationService.showSuccess(`Abrir barrera ${value.lane}. Orden enviada.`);
          this.openBarReassonSubscription.unsubscribe();
        }
      },
      err => {
        this.openBarReassonSubscription.unsubscribe();
        this.notificationService.showError(err);
      });
  }*/

  openBar(id: number): void {
    console.log('cerrar la barrera', id);
    const payload = {
      msg_type: 'open',
      lane: id,
      openingUser: this.authService.currentUser.name,
      openingMsg: 'BARCONTROL'
    };
    this.wsService.send('bar', payload);
  }

  closeBar(id: number): void {
    console.log('cerrar la barrera', id);
    const payload = {
      msg_type: 'close',
      lane: id
    };
    this.wsService.send('bar', payload);
  }

  // createVisit() crea una visita al vuelo
  /*
  createVisit(): void {
    const dialogRef = this.dialog.open(EditVisitDialogComponent, {
        width: '450px',
        disableClose: true,
        data: this.frontPlateForm.value
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.validatePlate(true);
      }
    });
  }

  validatePlate(retryAuth?: any){
    const plate = this.frontPlateForm.value;
    if (plate !== ''){
      const payload = {
        msg_type: 'newPlate',
        lane: this.laneId,
        data: {
          plate,
          retryAuth : retryAuth ? true : false
        }
      };
      this.wsService.send('newPlate', payload);
      console.log('New plate sent: ' + plate);
    }
  }*/

  getTimeStampSecond = (): string => {
    const now: Date = new Date();
    const seconds: string = ('0' + now.getSeconds().toString()).slice(-2);
    return seconds;
  }

  validateCurrentState(states, currentState) {
    if (states && states.length > 0 && states.includes(currentState)) {
      return true;
    } else {
      return false;
    }
  }


}